var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnSubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "27px",
    viewBox: "0 0 22 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bioscann-Create-Resource",
    transform: "translate(-926.000000, -578.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Invite-Student",
    filter: "url(#filter-1)",
    transform: "translate(890.000000, 568.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5625,18.0454545 L48.75,18.0454545 C48.5085,18.0454545 48.3125,18.2389091 48.3125,18.4772727 C48.3125,18.7160682 48.5085,18.9090909 48.75,18.9090909 L53.125,18.9090909 L53.125,30.1363636 L40.875,30.1363636 L40.875,18.9090909 L45.25,18.9090909 C45.4915,18.9090909 45.6875,18.7160682 45.6875,18.4772727 C45.6875,18.2389091 45.4915,18.0454545 45.25,18.0454545 L40.4375,18.0454545 C40.196,18.0454545 40,18.2389091 40,18.4772727 L40,30.5681818 C40,30.8069773 40.196,31 40.4375,31 L53.5625,31 C53.804,31 54,30.8069773 54,30.5681818 L54,18.4772727 C54,18.2389091 53.804,18.0454545 53.5625,18.0454545 M43.5,16.3181818 C43.62075,16.3181818 43.730125,16.27025 43.8093125,16.1916591 L46.5625,13.4742273 L46.5625,27.1136364 C46.5625,27.3524318 46.7585,27.5454545 47,27.5454545 C47.2415,27.5454545 47.4375,27.3524318 47.4375,27.1136364 L47.4375,13.4742273 L50.1906875,16.1916591 C50.269875,16.27025 50.37925,16.3181818 50.5,16.3181818 C50.7415,16.3181818 50.9375,16.1251591 50.9375,15.8863636 C50.9375,15.7676136 50.8885,15.6596591 50.8093125,15.5810682 L47.3093125,12.1265227 C47.230125,12.0483636 47.12075,12 47,12 C46.87925,12 46.769875,12.0483636 46.6906875,12.1265227 L43.1906875,15.5810682 C43.1115,15.6596591 43.0625,15.7676136 43.0625,15.8863636 C43.0625,16.1251591 43.2585,16.3181818 43.5,16.3181818",
    id: "Page-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSubmit);
export default __webpack_public_path__ + "static/media/icn_submit.dda8aa324a9e4900a4400f8a59bf4e34.svg";
export { ForwardRef as ReactComponent };